import type { IconProps } from '../types/IconProps.ts';
export const UserCog: IconProps = {
    name: 'UserCog',
    children: [
        `<path d="M12 13a5 5 0 1 0 0-10 5 5 0 0 0 0 10" />`,
        `<path d="M15.15 13.64A8 8 0 0 0 4 21" />`,
        `<circle cx="19" cy="19" r="2" />`,
        `<path d="M19 16v1M19 21v1M16 19h1M21 19h1M17 17l.5.5M20.5 20.5l.5.5M17 21l.5-.5M20.5 17.5l.5-.5" />`,
    ]
};